import React, { useEffect, useRef, useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TpFormDrawer from './TpFormDrawer';
import useUserPreferences from '../settings/userprefs/UserPreferencesHook';
import ReactHotkeys from 'react-hot-keys';
import LayoutByTp from '../layouts/LayoutByTp';
import { useWebsocketStore } from '../../../stores/websocketStore/websocketProvider';
import { AlertsMainPage } from '../alerts/alertsMainPage/AlertsMainPage';
import { observer } from 'mobx-react-lite';
import { TradierLoginModal } from '../notifications/tradierLoginModal/TradierLoginModal';

const initialState = {
  mouseX: null,
  mouseY: null,
};

export const AppMainPage = observer(() => {
  const { applicationTypeStore, tradierLoginStore } = useWebsocketStore();
  const applicationType = applicationTypeStore.applicationType ?? null;
  const loggedIn = tradierLoginStore?.loggedIn ?? null;
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const focusRef = useRef(null);
  const [state, setState] = React.useState(initialState);
  const [openTpDrawer, setOpenTpDrawer] = React.useState(false);
  const userPreferences = useUserPreferences();
  useEffect(() => {
    if (loggedIn !== null) {
      if (loggedIn === false) {
        setOpenLoginModal(true);
      }
      if (loggedIn === true) {
        setOpenLoginModal(false);
      }
    }
  }, [loggedIn]);
  if (applicationType === null) return null;
  if (applicationType === 'TU_ALERTS') return <AlertsMainPage />;
  const handleClose = () => {
    setState(initialState);
  };
  const openTpDrawerShortCut = 'alt+t';
  const shortcutKeyActions = {
    [openTpDrawerShortCut]: {
      action: () => {
        console.log('drawerOpen:' + openTpDrawer);
        setOpenTpDrawer(!openTpDrawer);
        if (focusRef.current !== null) {
          focusRef.current.focus();
        }
      },
    },
  };

  const onKeyDown = (keyName) => {
    shortcutKeyActions[keyName].action();
  };

  return (
    <div
    //  onContextMenu={handleClick} style={{ cursor: 'context-menu' }}
    >
      <TradierLoginModal
        open={openLoginModal}
        handleClose={() => setOpenLoginModal(false)}
        page="MAIN"
      />
      {/* <SoundAlerts /> */}
      <ReactHotkeys keyName={openTpDrawerShortCut} onKeyDown={onKeyDown}>
        <LayoutByTp userPreferences={userPreferences} />
        <Menu
          style={{
            position: 'fixed',
            boxShadow: '0px 2px 10px #999999',
          }}
          keepMounted
          open={state.mouseY !== null}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            state.mouseY !== null && state.mouseX !== null
              ? { top: state.mouseY, left: state.mouseX }
              : undefined
          }
        >
          <MenuItem
            style={{ fontSize: 10 }}
            onClick={() => {
              setOpenTpDrawer(true);
              handleClose();
            }}
          >
            AddTradePlan
          </MenuItem>
        </Menu>
        <TpFormDrawer
          drawerOpen={openTpDrawer}
          setDrawerOpen={setOpenTpDrawer}
          userPreferences={userPreferences}
          focusRef={focusRef}
        />
      </ReactHotkeys>
    </div>
  );
});
/*

    let goLongShortCut = "alt+l";
    let goShortShortCut = "alt+s";
    let openTradeShortCut = "enter";
    let symbolFocusShortCut = "alt+n";
    let setStockShortCut = "alt+k";
    let setOptionShortCut = "alt+o";
    let shortcutKeyActions = {
        [goLongShortCut]: {action: () => setPositionDirection("LONG")},
        [goShortShortCut]: {action: () => setPositionDirection("SHORT")},
        [openTradeShortCut]: {action: () => openTrade()},
        [setStockShortCut]: {
            action: () => {
                dispatchTop({instrument: "stock"})
            }
        },
        [setOptionShortCut]: {
            action: () => {
                dispatchTop({instrument: "option"})
            }
        },
        [symbolFocusShortCut]: {action: () => focusRef.current.focus()}
    }

    const onKeyDown = (keyName, e, handle) => {
        shortcutKeyActions[keyName].action();
    }
    return (
        <>
            <ReactHotkeys
                keyName={goLongShortCut + "," + goShortShortCut + "," +
                openTradeShortCut + "," + setStockShortCut + "," + setOptionShortCut}
                onKeyDown={onKeyDown}
            >
 */
